/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AssignRemoveOrgsFromOauthAppResponse { 
    /**
     * List of orgs successfully assigned.
     */
    successfullyAssigned?: Array<string>;
    /**
     * List of orgs successfully removed.
     */
    successfullyRemoved?: Array<string>;
    /**
     * List of orgs failed to assign.
     */
    failedToAssign?: Array<string>;
    /**
     * List of orgs failed to remove.
     */
    failedToRemove?: Array<string>;
}

